import React, {Suspense} from "react";
import {deleteDocument} from "../../utils/Api";
import _ from "lodash";
import {useRecoilState} from "recoil";
import {documentListAtom} from "../../recoil/atoms/documentAtoms";

const DocumentList = () => {
    const [documents, setDocuments] = useRecoilState(documentListAtom)

    const handleDelete = (id) => {
        deleteDocument(id).then(() => {
            setDocuments(_.filter(documents, (document) => {
                return document.id !== id;
            }))
        })
    }

    return (
        <div>
            { _.map(documents, (document) => {
                return <li key={document.id}>{document.name} <button onClick={() => handleDelete(document.id)}>Delete</button></li>
            })}
        </div>
    )
}

export const DocumentContainer = () => {

    return (
        <div>
            <h2>Documents</h2>
            <Suspense fallback={<div>Loading...</div>}>
                <DocumentList />
            </Suspense>
            <button onClick={() => console.log('create')}>Create</button>
        </div>
    )
}